export default "__VITE_ASSET__X5NCGN6s__"